import { render, staticRenderFns } from "./forceFinishRepair.vue?vue&type=template&id=0bb80460"
import script from "./forceFinishRepair.vue?vue&type=script&lang=js"
export * from "./forceFinishRepair.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports